import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon, ChevronDownIcon } from 'lucide-react';
export function Navigation() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const [aboutOpen, setAboutOpen] = useState(false);
  const location = useLocation();
  // Close mobile menu on route change
  useEffect(() => {
    setMobileOpen(false);
    setServicesOpen(false);
    setAboutOpen(false);
  }, [location.pathname]);
  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };
  return <nav className="sticky top-0 z-50 bg-white shadow-sm border-b border-gray-200" data-id="element-214" data-mp="f0291fl29yto">
      <div className="max-w-[1200px] mx-auto px-5 md:px-10 lg:px-15" data-id="element-215" data-mp="t03kfoyycone">
        <div className="flex items-center justify-between h-20" data-id="element-216" data-mp="syacm6clrydt">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0" data-id="element-217" data-mp="p0mekufm5php">
            <img src="https://cdn.magicpatterns.com/uploads/rgcJwPHo8cNW53rsocngGA/NewRiver-Logo-FC-1000x287v2.png" alt="New River Systems" className="h-10 w-auto" data-id="element-218" data-mp="dg7gn6x3o4rq" />
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-219" data-mp="mg49lkqivpsl">
            {/* Home Link */}
            <Link to="/" className={`py-8 text-base font-bold transition-colors border-b-4 ${isActive('/') && location.pathname === '/' ? 'text-nrs-navy border-nrs-orange' : 'text-gray-600 border-transparent hover:text-nrs-orange'}`} data-id="element-220" data-mp="rfqnlwe6da2g">
              Home
            </Link>

            {/* About Dropdown */}
            <div className="relative group" onMouseEnter={() => setAboutOpen(true)} onMouseLeave={() => setAboutOpen(false)} data-id="element-221" data-mp="157wuervfu4p8">
              <button className={`flex items-center gap-1 py-8 text-base font-bold transition-colors border-b-4 ${isActive('/about-us') ? 'text-nrs-navy border-nrs-orange' : 'text-gray-600 border-transparent hover:text-nrs-orange'}`} data-id="element-222" data-mp="1a56q2p9f7cli">
                About Us
                <ChevronDownIcon className="h-4 w-4" data-id="element-223" data-mp="uf7f6h4h3gga" />
              </button>

              {aboutOpen && <div className="absolute top-full left-0 w-56 bg-white border border-gray-200 shadow-lg rounded-b-md py-2 z-50" data-id="element-224" data-mp="phfjdc0pja6t">
                  <Link to="/about-us" className="block px-4 py-2 text-sm text-gray-700 hover:bg-nrs-light hover:text-nrs-navy font-bold" data-id="element-225" data-mp="147d39frltdq7">
                    About New River
                  </Link>
                  <Link to="/about-us/our-team" className="block px-4 py-2 text-sm text-gray-700 hover:bg-nrs-light hover:text-nrs-navy font-bold" data-id="element-226" data-mp="1d4x5os17dg2e">
                    Leadership Team
                  </Link>
                  <Link to="/about-us/partners" className="block px-4 py-2 text-sm text-gray-700 hover:bg-nrs-light hover:text-nrs-navy font-bold" data-id="element-227" data-mp="1n3whukl6ftu5">
                    Partners
                  </Link>
                  <Link to="/about-us/community" className="block px-4 py-2 text-sm text-gray-700 hover:bg-nrs-light hover:text-nrs-navy font-bold" data-id="element-228" data-mp="3owav36cs0a48">
                    Community Impact
                  </Link>
                  <Link to="/about-us/certifications" className="block px-4 py-2 text-sm text-gray-700 hover:bg-nrs-light hover:text-nrs-navy font-bold" data-id="element-229" data-mp="1zh05h1qirfaw">
                    Certifications
                  </Link>
                  <Link to="/about-us/contract-vehicles" className="block px-4 py-2 text-sm text-gray-700 hover:bg-nrs-light hover:text-nrs-navy font-bold" data-id="element-230" data-mp="1uo72ojem2h1g">
                    Contract Vehicles
                  </Link>
                </div>}
            </div>

            {/* Services Dropdown */}
            <div className="relative group" onMouseEnter={() => setServicesOpen(true)} onMouseLeave={() => setServicesOpen(false)} data-id="element-231" data-mp="1knodra86waco">
              <button className={`flex items-center gap-1 py-8 text-base font-bold transition-colors border-b-4 ${isActive('/services') ? 'text-nrs-navy border-nrs-orange' : 'text-gray-600 border-transparent hover:text-nrs-orange'}`} data-id="element-232" data-mp="1bojdnzgzc8ye">
                Services
                <ChevronDownIcon className="h-4 w-4" data-id="element-233" data-mp="360zqjj4a6lc8" />
              </button>

              {servicesOpen && <div className="absolute top-full left-0 w-64 bg-white border border-gray-200 shadow-lg rounded-b-md py-2 z-50" data-id="element-234" data-mp="15yqhbxp66muc">
                  <Link to="/services" className="block px-4 py-2 text-sm text-nrs-navy hover:bg-nrs-light font-bold" data-id="element-235" data-mp="wzwomieymgm2">
                    View All Services
                  </Link>
                  <div className="h-px bg-gray-200 my-2" data-id="element-236" data-mp="n28ikwbwlmol"></div>
                  <Link to="/services/ai" className="block px-4 py-2 text-sm text-gray-700 hover:bg-nrs-light hover:text-nrs-navy font-bold" data-id="element-237" data-mp="n3tf2rhs3fp3">
                    AI & Intelligent Automation
                  </Link>
                  <Link to="/services/servicenow" className="block px-4 py-2 text-sm text-gray-700 hover:bg-nrs-light hover:text-nrs-navy font-bold" data-id="element-238" data-mp="dacjpj1ztsjb">
                    ServiceNow
                  </Link>
                  <Link to="/services/identity-access-management" className="block px-4 py-2 text-sm text-gray-700 hover:bg-nrs-light hover:text-nrs-navy font-bold" data-id="element-239" data-mp="4dldwexn2zbj">
                    ICAM Services
                  </Link>
                  <Link to="/services/program-and-project-management" className="block px-4 py-2 text-sm text-gray-700 hover:bg-nrs-light hover:text-nrs-navy font-bold" data-id="element-240" data-mp="2fyuaua709xy7">
                    Program Management
                  </Link>
                </div>}
            </div>

            <Link to="/careers" className={`py-8 text-base font-bold transition-colors border-b-4 ${isActive('/careers') ? 'text-nrs-navy border-nrs-orange' : 'text-gray-600 border-transparent hover:text-nrs-orange'}`} data-id="element-241" data-mp="2oxg0sqet4f90">
              Careers
            </Link>

            <Link to="/contact-us" className={`py-8 text-base font-bold transition-colors border-b-4 ${isActive('/contact-us') ? 'text-nrs-navy border-nrs-orange' : 'text-gray-600 border-transparent hover:text-nrs-orange'}`} data-id="element-242" data-mp="219elmyn4i0km">
              Contact
            </Link>
          </div>

          {/* Mobile hamburger */}
          <button className="md:hidden p-2 text-nrs-orange" onClick={() => setMobileOpen(!mobileOpen)} aria-label="Toggle menu" data-id="element-243" data-mp="1disq26ub28ri">
            {mobileOpen ? <XIcon className="h-8 w-8" data-id="element-244" data-mp="2bwpsjnbvwtsg" /> : <MenuIcon className="h-8 w-8" data-id="element-245" data-mp="2bvep5omcpo1v" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {mobileOpen && <div className="fixed inset-0 top-20 bg-nrs-navy z-40 overflow-y-auto" data-id="element-246" data-mp="2qnf6gxgqcn00">
          <div className="px-5 py-6 space-y-6" data-id="element-247" data-mp="2lmrhehc2ag8f">
            {/* Home */}
            <div data-id="element-248" data-mp="1xxq52j03ykxv">
              <Link to="/" className="block text-white text-xl font-bold mb-4" data-id="element-249" data-mp="1xx6yfyfwriz5">
                Home
              </Link>
            </div>

            <div data-id="element-250" data-mp="26xdargzvecwq">
              <div className="text-white/50 text-sm font-bold uppercase tracking-wider mb-3" data-id="element-251" data-mp="26xv3i3nbq8zw">
                Company
              </div>
              <div className="space-y-3 pl-4 border-l border-white/20" data-id="element-252" data-mp="22u6vjjus5be4">
                <Link to="/about-us" className="block text-white text-lg font-bold" data-id="element-253" data-mp="3ibqqfykgzm1o">
                  About New River
                </Link>
                <Link to="/about-us/our-team" className="block text-white text-lg font-bold" data-id="element-254" data-mp="3ecztpsjx26f3">
                  Leadership Team
                </Link>
                <Link to="/about-us/partners" className="block text-white text-lg font-bold" data-id="element-255" data-mp="3qtss9gqns2av">
                  Partners
                </Link>
                <Link to="/about-us/community" className="block text-white text-lg font-bold" data-id="element-256" data-mp="3by35hgdnfl53">
                  Community Impact
                </Link>
                <Link to="/about-us/certifications" className="block text-white text-lg font-bold" data-id="element-257" data-mp="8f9r51d1qs9v">
                  Certifications
                </Link>
                <Link to="/about-us/contract-vehicles" className="block text-white text-lg font-bold" data-id="element-258" data-mp="dgpgh5m9bky2">
                  Contract Vehicles
                </Link>
              </div>
            </div>

            <div data-id="element-259" data-mp="3mqhgfhhchac">
              <div className="text-white/50 text-sm font-bold uppercase tracking-wider mb-3" data-id="element-260" data-mp="redw9z1gw1w9">
                Services
              </div>
              <div className="space-y-3 pl-4 border-l border-white/20" data-id="element-261" data-mp="w65oee09ufoi">
                <Link to="/services" className="block text-nrs-light text-lg font-bold" data-id="element-262" data-mp="2s8sdcfa4lli6">
                  View All Services
                </Link>
                <Link to="/services/ai" className="block text-white text-lg font-bold pt-2" data-id="element-263" data-mp="2ng8yzg3m6mcb">
                  AI & Intelligent Automation
                </Link>
                <Link to="/services/servicenow" className="block text-white text-lg font-bold" data-id="element-264" data-mp="2ehn9t23n092k">
                  ServiceNow
                </Link>
                <Link to="/services/identity-access-management" className="block text-white text-lg font-bold" data-id="element-265" data-mp="3b50k5nise4fl">
                  ICAM Services
                </Link>
                <Link to="/services/program-and-project-management" className="block text-white text-lg font-bold" data-id="element-266" data-mp="32554b5eadl98">
                  Program Management
                </Link>
              </div>
            </div>

            <div className="pt-4 border-t border-white/20" data-id="element-267" data-mp="1qsukhohiszgx">
              <Link to="/careers" className="block text-white text-xl font-bold mb-4" data-id="element-268" data-mp="1lrn9zhnztm6k">
                Careers
              </Link>
              <Link to="/contact-us" className="block text-white text-xl font-bold" data-id="element-269" data-mp="1bpt5kz0iz4q9">
                Contact
              </Link>
            </div>
          </div>
        </div>}
    </nav>;
}